var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class CountryConfiguration {
  constructor(_data) {
    /**
     */
    __publicField(this, "CountryCode");
    /**
     */
    __publicField(this, "IsActive");
    /**
     */
    __publicField(this, "IsAvailable");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CountryConfiguration
     */
    __publicField(this, "$type", "V1.VATNumberValidationConfiguration.CountryConfiguration");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.CountryCode = _data["CountryCode"];
      this.IsActive = _data["IsActive"];
      this.IsAvailable = _data["IsAvailable"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["CountryCode"] = this.CountryCode;
    _data["IsActive"] = this.IsActive;
    _data["IsAvailable"] = this.IsAvailable;
    return _data;
  }
}
